<div class="city-bg" style="background-image: url(/images/city.svg);"></div>
<div class="login-container drop-shadow bottom">
  <h1 class="login--header">Forgotten Password</h1>
  <form [formGroup]="form" (ngSubmit)="submit(form)" class="std-form" autocomplete="off" novalidate>
    <p>Enter your email address to reset your password.</p>
    <div class="form-group" [ngClass]="{'danger': form.controls['email'].invalid && submitted}">
      <label for="email">Email address</label>
      <input id="email" class="form-control" type="email" placeholder="user@email.com" [formControl]="form.controls['email']">
      <span *ngIf="form.controls['email'].hasError('email') && submitted" class="validation-msg">Please provide a valid e-mail address.</span>
    </div>
    <div class="btn-group center margin">
      <button class="std-btn focus-element" type="submit" [disabled]="submitting"><span class="focus--content" tabindex="-1">{{submitting === true ? "Requesting..." : "Submit"}}</span></button>
    </div>
  </form>
</div>

